export default "__VITE_ASSET__PnC$gC3s__"